export const formConfig = [
  {
    name: "year",
    config: {
      col: "md",
      validate: true,
      colWidth: "2",
      label: "Year",
      placeholder: "Select a Year",
      type: "select",
      apiEndpoint: "api/v1/hwts/search/ship-years",
      hasApi: true,
    },
  },
  {
    name: "type",
    config: {
      col: "md",
      validate: true,
      colWidth: "2",
      label: "Tonnage By",
      placeholder: "Select Tonnage By",
      type: "select",
      hasApi: false,
      data: [
        {
          label: "Entity Type",
          value: 1,
        },
        {
          label: "Method Code",
          value: 2,
        },
        {
          label: "Waste Code",
          value: 3,
        },
      ],
    },
  },
  {
    name: "entityType",
    config: {
      col: "md",
      validate: true,
      colWidth: "2",
      label: "Select by",
      placeholder: "Select a Type",
      type: "select",
      hasApi: false,
      data: [
        { value: "City", label: "City" },
        { value: "CUPA", label: "CUPA Region" },
        { value: "County", label: "County" },
        { value: "EpaId", label: "ID Number" },
      ],
    },
  },
  {
    name: "epaId",
    config: {
      col: "md",
      validate: true,
      colWidth: "3",
      label: "ID Number",
      placeholder: "Enter a ID Number",
      type: "text",
      hasApi: false,
      data: [],
    },
  },
  {
    name: "city",
    config: {
      col: "md",
      colWidth: "3",
      label: "City",
      placeholder: "Select a City",
      type: "select",
      apiEndpoint: "api/v1/hwts/search/cities",
      hasApi: true,
    },
  },
  {
    name: "county",
    config: {
      col: "md",
      validate: true,
      colWidth: "3",
      label: "County",
      placeholder: "Select a County",
      type: "select",
      apiEndpoint: "api/v1/hwts/search/counties",
      hasApi: true,
    },
  },

  {
    name: "cupa",
    config: {
      col: "md",
      validate: true,
      colWidth: "3",
      label: "CUPA",
      placeholder: "Select a CUPA",
      type: "select",
      apiEndpoint: "api/v1/hwts/search/cupas",
      hasApi: true,
    },
  },
  {
    name: "entity",
    config: {
      col: "md",
      validate: true,
      colWidth: "3",
      label: "Entity Type",
      placeholder: "Select an Entity Type",
      type: "select",
      hasApi: false,
      data: [
        { value: "Generator", label: "Generator" },
        { value: "Transporter", label: "Transporter" },
        { value: "DesignatedFacility", label: "TSDF" },
        { value: "AlternateDesignateFacility", label: "Alt. TSDF" },
      ],
    },
  },
  {
    name: "methCode",
    config: {
      col: "md",
      colWidth: "3",
      label: "Method Code",
      placeholder: "",
      type: "select",
      apiEndpoint: "api/v1/hwts/search/method-codes",
      hasApi: true,
    },
  },
  {
    name: "wasteCodeType",
    config: {
      col: "md",
      validate: true,
      colWidth: "2",
      label: "Waste Type",
      placeholder: "Select a Waste Type",
      type: "select",
      hasApi: false,
      data: [
        { value: "all", label: "All" },
        { value: "rcra", label: "RCRA" },
        { value: "ca", label: "Non-RCRA" },
      ],
    },
  },
  {
    name: "allWasteCode",
    config: {
      col: "md",
      colWidth: "3",
      label: "Waste Code",
      placeholder: "",
      type: "select",
      apiEndpoint: "api/v1/hwts/search/wastecodes/all",
      hasApi: true,
    },
  },
  {
    name: "rcraWasteCode",
    config: {
      col: "md",
      colWidth: "3",
      label: "Waste Code",
      placeholder: "",
      type: "select",
      apiEndpoint: "api/v1/hwts/search/wastecodes/rcra",
      hasApi: true,
    },
  },
  {
    name: "caWasteCode",
    config: {
      col: "md",
      colWidth: "3",
      label: "Waste Code",
      placeholder: "",
      type: "select",
      apiEndpoint: "api/v1/hwts/search/wastecodes/ca",
      hasApi: true,
    },
  },
  {
    name: "greaterThan",
    config: {
      col: "md",
      validate: true,
      colWidth: "3",
      label: "Tonnage Greater Than",
      placeholder: "",
      type: "text",
      hasApi: false,
      data: [],
    },
  },
];
